export const targetAccounts = {
  development: 101014,
  test: 101014,
  production: 101014,
  // production: 105348,
};

export default targetAccounts[process.env.REACT_APP_ENV];
